import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-74b13b8f"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "ba-left-side"
};
const _hoisted_2 = {
  class: "ba-product-info ba-product-info-regular"
};
const _hoisted_3 = ["src", "alt"];
const _hoisted_4 = {
  class: "details"
};
const _hoisted_5 = {
  class: "ba-text ba-text-xs ba-text-lighter"
};
const _hoisted_6 = {
  class: "tooltip-text",
  style: {
    "font-weight": "700"
  }
};
const _hoisted_7 = {
  class: "paused-product-ads-count"
};
const _hoisted_8 = {
  class: "tooltip-text",
  style: {
    "font-weight": "700"
  }
};
const _hoisted_9 = ["id"];
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "ba-text ba-text-xs ba-text-yellow"
}, " Low inventory ", -1));
const _hoisted_11 = {
  class: "days ba-text ba-text-xs tooltip-text"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "color": "#bfbfbf"
  }
}, " of inventory left", -1));
const _hoisted_13 = {
  class: "ba-product-info-prioritized"
};
const _hoisted_14 = {
  class: "ba-product-data ba-product-data-bottom ba-product-data-regular"
};
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "cap-4w-popover-heading"
}, " Target ACOS/ROAS", -1));
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "cap-4w-popover-content"
}, " Product Margin x Margin ", -1));
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("p", {
  class: "cap-4w-popover-content"
}, " Reinvestment x Boost ", -1));
const _hoisted_18 = {
  class: "ba-right-side"
};
const _hoisted_19 = {
  class: "ba-perfomance ba-perfomance-bottom ba-perfomance-regular"
};
const _hoisted_20 = {
  class: "ba-discovery ba-discovery-bottom ba-discovery-regular"
};
const _hoisted_21 = {
  key: 1,
  class: "modal-content-text"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_ppc_b_a_block_cell = _resolveComponent("ppc-b-a-block-cell");
  const _component_ppc_inconsistent_state_popover = _resolveComponent("ppc-inconsistent-state-popover");
  const _component_ppc_b_a_state_cell = _resolveComponent("ppc-b-a-state-cell");
  const _component_app_icon = _resolveComponent("app-icon");
  const _component_app_popover = _resolveComponent("app-popover");
  const _component_pause_icon = _resolveComponent("pause-icon");
  const _component_currency_value = _resolveComponent("currency-value");
  const _component_ppc_b_a_product_info_cell = _resolveComponent("ppc-b-a-product-info-cell");
  const _component_ppc_s_p_product_ads = _resolveComponent("ppc-s-p-product-ads");
  const _component_ppc_b_a_prioritized_by_cell = _resolveComponent("ppc-b-a-prioritized-by-cell");
  const _component_ppc_b_a_product_margin_cell = _resolveComponent("ppc-b-a-product-margin-cell");
  const _component_ppc_b_a_boost_cell = _resolveComponent("ppc-b-a-boost-cell");
  const _component_ppc_b_a_acos_roas_cell = _resolveComponent("ppc-b-a-acos-roas-cell");
  const _component_ppc_b_a_budget_cell = _resolveComponent("ppc-b-a-budget-cell");
  const _component_ppc_b_a_max_potential_percent_cell = _resolveComponent("ppc-b-a-max-potential-percent-cell");
  const _component_ppc_b_a_vs_last_week_spend_cell = _resolveComponent("ppc-b-a-vs-last-week-spend-cell");
  const _component_ppc_campaign_group_info = _resolveComponent("ppc-campaign-group-info");
  const _component_ppc_budget_allocation_weekly_budget_edit = _resolveComponent("ppc-budget-allocation-weekly-budget-edit");
  const _component_app_modal = _resolveComponent("app-modal");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createElementVNode("div", {
    class: _normalizeClass(["ba-row", $options.getRowClass])
  }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_ppc_b_a_block_cell, {
    is_blocked: $options.processedItem.isBlocked,
    campaign_group_state: !!$options.campaignGroupState,
    item_id: `blocked${$options.processedItem.id}`,
    onBlockToggled: $options.onBlockToggle
  }, null, 8, ["is_blocked", "campaign_group_state", "item_id", "onBlockToggled"]), _createVNode(_component_ppc_b_a_state_cell, {
    item_id: `enabled${$options.processedItem.id}`,
    loading: $props.still_initializing || $data.edit_campaign_loading,
    state: $options.campaignGroupState,
    onStateChange: _cache[2] || (_cache[2] = val => {
      this.onApplyState(val ? 'ENABLED' : 'PAUSED');
    })
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_inconsistent_state_popover, {
      onPauseAll: _cache[0] || (_cache[0] = $event => $options.onApplyState('PAUSED')),
      onEnableAll: _cache[1] || (_cache[1] = $event => $options.onApplyState('ENABLED'))
    })]),
    _: 1
  }, 8, ["item_id", "loading", "state"]), _createVNode(_component_ppc_b_a_product_info_cell, {
    name: $options.processedItem.name,
    image: $options.processedItem.image,
    item_id: `name${$options.processedItem.id}`,
    class: "sp_ba_product_info",
    id: `productads${$options.processedItem.id}`
  }, {
    details: _withCtx(() => [$options.processedItem.flag ? (_openBlock(), _createElementBlock("img", {
      key: 0,
      src: $options.processedItem.flag,
      class: "flag",
      alt: $options.processedItem.countryCode
    }, null, 8, _hoisted_3)) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_4, [_createVNode(_component_app_icon, {
      icon: "sub",
      id: `sp_details${$options.processedItem.id}`
    }, null, 8, ["id"]), _createElementVNode("div", _hoisted_5, _toDisplayString($options.processedItem.subDetails), 1), _createVNode(_component_app_popover, {
      target: `sp_details${$options.processedItem.id}`,
      placement: "right"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_6, _toDisplayString($options.processedItem.subDetails) + " grouped ASIN" + _toDisplayString($options.processedItem.subDetails > 1 ? 's' : ''), 1)]),
      _: 1
    }, 8, ["target"])]), _withDirectives(_createElementVNode("div", _hoisted_7, [_createVNode(_component_pause_icon, {
      id: `sp_paused_ads_count${$options.processedItem.id}`
    }, null, 8, ["id"]), _createTextVNode(" " + _toDisplayString($options.getPausedProductAdsLength) + " ", 1), _createVNode(_component_app_popover, {
      target: `sp_paused_ads_count${$options.processedItem.id}`,
      placement: "right"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_8, _toDisplayString($options.getPausedProductAdsLength) + " paused product" + _toDisplayString($options.getPausedProductAdsLength > 1 ? 's' : ''), 1)]),
      _: 1
    }, 8, ["target"])], 512), [[_vShow, $options.getPausedProductAdsLength]]), _withDirectives(_createElementVNode("div", {
      id: `invent${$options.processedItem.id}`,
      class: "days-low"
    }, [_createVNode(_component_app_icon, {
      icon: "alert"
    }), _hoisted_10], 8, _hoisted_9), [[_vShow, $options.processedItem.daysInventory && $options.processedItem.daysInventory < 15]]), _createVNode(_component_app_popover, {
      target: `invent${$options.processedItem.id}`,
      "auto-width": "",
      "auto-height": "",
      placement: "top"
    }, {
      default: _withCtx(() => [_createElementVNode("div", _hoisted_11, [_createVNode(_component_currency_value, {
        value: $options.processedItem.daysInventory,
        showSymbol: false,
        precision: 0
      }, null, 8, ["value"]), _createTextVNode("  day" + _toDisplayString($options.processedItem.daysInventory > 1 ? "s" : "") + " ", 1), _hoisted_12])]),
      _: 1
    }, 8, ["target"])]),
    badge: _withCtx(() => [$options.shouldDisplayBadge ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(['badge ba-text ba-text-small', {
        [$options.processedItem.result]: !!$options.processedItem.result
      }, {
        blocked: $options.processedItem.isBlocked
      }])
    }, [!$options.processedItem.isBlocked ? (_openBlock(), _createBlock(_component_app_icon, {
      key: 0,
      icon: "ai",
      size: 12
    })) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString($options.getBadgeText), 1)], 2)) : _createCommentVNode("", true)]),
    _: 1
  }, 8, ["name", "image", "item_id", "id"]), _createVNode(_component_app_popover, {
    target: `productads${$options.processedItem.id}`,
    "auto-width": "",
    "auto-height": "",
    placement: "top",
    click: "",
    "no-arrow": "",
    popup: "",
    boundary: "viewport"
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_s_p_product_ads, {
      items: $options.getItemProductAds,
      selected_profile_id: $props.selected_profile_id,
      country_code: $options.processedItem.countryCode,
      group_by_type: $options.getProductAdsGroupByType(),
      selected_seller: $props.selected_seller,
      onClose: _cache[3] || (_cache[3] = $event => $options.onClosePopover(`productads${$options.processedItem.id}`))
    }, null, 8, ["items", "selected_profile_id", "country_code", "group_by_type", "selected_seller"])]),
    _: 1
  }, 8, ["target"]), _createElementVNode("div", _hoisted_13, [_createVNode(_component_ppc_b_a_prioritized_by_cell, {
    value: $options.processedItem.adsNetProfit4W,
    currency: $props.currency,
    precision: $data.currency_precision,
    allowPrecisionModification: false,
    type: "ads_net_profit"
  }, null, 8, ["value", "currency", "precision"]), _createVNode(_component_ppc_b_a_prioritized_by_cell, {
    value: $options.processedItem.revShare4W,
    type: "rev_share"
  }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_14, [_createElementVNode("div", {
    class: _normalizeClass(["ba-product-data-content", {
      last: $props.last
    }])
  }, [_createVNode(_component_ppc_b_a_product_margin_cell, {
    value: $options.processedItem.productsMarginValue,
    percentage_value: $options.processedItem.productsMargin,
    currency: $props.currency
  }, null, 8, ["value", "percentage_value", "currency"]), _createVNode(_component_ppc_b_a_boost_cell, {
    value: $options.processedItem.boost,
    onBoostChange: $options.onBoostChange
  }, null, 8, ["value", "onBoostChange"]), _createVNode(_component_ppc_b_a_acos_roas_cell, {
    mode: $props.mode,
    acos4W: $options.processedItem.acos4W,
    roas4W: $options.processedItem.roas4W,
    cap: $options.processedItem.cap,
    item_id: `cap-4w${$options.processedItem.id}`,
    class: _normalizeClass($options.getCapColor)
  }, {
    popover_content: _withCtx(() => [_hoisted_15, _hoisted_16, _hoisted_17]),
    _: 1
  }, 8, ["mode", "acos4W", "roas4W", "cap", "item_id", "class"])], 2)])]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createElementVNode("div", {
    class: _normalizeClass(["ba-perfomance-content", {
      last: $props.last
    }])
  }, [_createVNode(_component_ppc_b_a_budget_cell, {
    item_id: `weeklyperf${$options.processedItem.id}`,
    class: _normalizeClass({
      'weekly-edit': $props.weeklyBudgetTarget == `weeklyperf${$options.processedItem.id}`
    }),
    loading: $props.still_initializing || $data.edit_campaign_loading,
    item: $options.processedItem.perfomance,
    currency: $props.currency,
    currency_precision: $data.currency_precision,
    is_paused: !$options.campaignGroupState || $options.campaignGroupState === 'inconsistent',
    onWeeklyEdit: _cache[4] || (_cache[4] = $event => $options.onWeeklyEdit('perf')),
    onWeeklyReset: _cache[5] || (_cache[5] = $event => $options.onWeeklyReset('perf')),
    onWeeklyPopupShown: _cache[6] || (_cache[6] = $event => $options.onWeeklyEditPopupShown(`weeklyperf${$options.processedItem.id}`)),
    onWeeklyPopupHidden: _cache[7] || (_cache[7] = $event => $options.onWeeklyEditPopupHidden(`weeklyperf${$options.processedItem.id}`))
  }, null, 8, ["item_id", "class", "loading", "item", "currency", "currency_precision", "is_paused"]), _createVNode(_component_ppc_b_a_max_potential_percent_cell, {
    item_id: `potentialPerformance${$options.processedItem.id}`,
    value: $options.processedItem.perfomance.potential,
    potential_budget: $options.processedItem.perfomance.budgetPotential,
    current_budget: $options.processedItem.perfomance.budgetCurrent,
    currency: $props.currency,
    currency_precision: $data.currency_precision
  }, null, 8, ["item_id", "value", "potential_budget", "current_budget", "currency", "currency_precision"]), _createVNode(_component_ppc_b_a_vs_last_week_spend_cell, {
    item_id: `perfomancelastweek${$options.processedItem.id}`,
    value: $options.processedItem.perfomance.previous,
    previous_week_value: $options.processedItem.perfomance.previous_week_spend,
    currency: $props.currency,
    currency_precision: $data.currency_precision
  }, null, 8, ["item_id", "value", "previous_week_value", "currency", "currency_precision"])], 2)]), _createElementVNode("div", _hoisted_20, [_createElementVNode("div", {
    class: _normalizeClass(["ba-discovery-content", {
      last: $props.last
    }])
  }, [_createVNode(_component_ppc_b_a_budget_cell, {
    item_id: `weeklydiscovery${$options.processedItem.id}`,
    class: _normalizeClass({
      'weekly-edit': $props.weeklyBudgetTarget == `weeklydiscovery${$options.processedItem.id}`
    }),
    loading: $props.still_initializing || $data.edit_campaign_loading,
    item: $options.processedItem.discovery,
    currency: $props.currency,
    currency_precision: $data.currency_precision,
    is_paused: !$options.campaignGroupState || $options.campaignGroupState === 'inconsistent',
    onWeeklyEdit: _cache[8] || (_cache[8] = $event => $options.onWeeklyEdit('discovery')),
    onWeeklyReset: _cache[9] || (_cache[9] = $event => $options.onWeeklyReset('discovery')),
    onWeeklyPopupShown: _cache[10] || (_cache[10] = $event => $options.onWeeklyEditPopupShown(`weeklydiscovery${$options.processedItem.id}`)),
    onWeeklyPopupHidden: _cache[11] || (_cache[11] = $event => $options.onWeeklyEditPopupHidden(`weeklydiscovery${$options.processedItem.id}`))
  }, null, 8, ["item_id", "class", "loading", "item", "currency", "currency_precision", "is_paused"]), _createVNode(_component_ppc_b_a_max_potential_percent_cell, {
    item_id: `potentialDiscovery${$options.processedItem.id}`,
    value: $options.processedItem.discovery.potential,
    potential_budget: $options.processedItem.discovery.budgetPotential,
    current_budget: $options.processedItem.discovery.budgetCurrent,
    currency: $props.currency,
    currency_precision: $data.currency_precision
  }, null, 8, ["item_id", "value", "potential_budget", "current_budget", "currency", "currency_precision"]), _createVNode(_component_ppc_b_a_vs_last_week_spend_cell, {
    item_id: `discoverylastweek${$options.processedItem.id}`,
    value: $options.processedItem.discovery.previous,
    previous_week_value: $options.processedItem.discovery.previous_week_spend,
    currency: $props.currency,
    currency_precision: $data.currency_precision
  }, null, 8, ["item_id", "value", "previous_week_value", "currency", "currency_precision"])], 2)])])], 2), _createVNode(_component_app_modal, {
    modelValue: $data.changeModal,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.changeModal = $event),
    title: $options.isBudgetModal ? 'Budget Allocation' : 'Confirm Campaign Group Update',
    "cancel-title": "No",
    "ok-title": "Yes",
    onOk: _cache[13] || (_cache[13] = $event => $data.confirmBlockModalOkMap[$data.change_modal_type]()),
    onCancel: _cache[14] || (_cache[14] = $event => $options.isBudgetModal ? $options.onWeeklyBudgetEditCancel() : $options.onModalCancel()),
    custom_class: `confirm-block-modal ${$data.change_modal_type}`,
    noCancel: $options.isBudgetModal,
    noOk: $options.isBudgetModal,
    noFooter: $options.isBudgetModal,
    no_close_on_outside_click: $options.isBudgetModal
  }, {
    default: _withCtx(() => [_createVNode(_component_ppc_campaign_group_info, {
      item: $options.processedItem,
      blockIconColor: _ctx.getBlockIconColor,
      ai_status: $options.getBadgeText,
      state: $options.campaignGroupState
    }, null, 8, ["item", "blockIconColor", "ai_status", "state"]), $options.isBudgetModal ? (_openBlock(), _createBlock(_component_ppc_budget_allocation_weekly_budget_edit, {
      key: 0,
      data: $options.processedItem[$data.change_modal_data_type],
      currency: $props.currency,
      country_code: $options.processedItem.countryCode,
      mode: $props.mode,
      open: $data.weeklyBudgetShown == `weeklydiscovery${$options.processedItem.id}`,
      type: $data.change_modal_data_type,
      onCancel: $options.onWeeklyBudgetEditCancel,
      onApply: $options.onWeeklyBudgetEditApply
    }, null, 8, ["data", "currency", "country_code", "mode", "open", "type", "onCancel", "onApply"])) : (_openBlock(), _createElementBlock("div", _hoisted_21, _toDisplayString($data.change_modal_text), 1))]),
    _: 1
  }, 8, ["modelValue", "title", "custom_class", "noCancel", "noOk", "noFooter", "no_close_on_outside_click"])], 64);
}